import { render, staticRenderFns } from "./RuleEffective.vue?vue&type=template&id=499f11da"
import script from "./RuleEffective.vue?vue&type=script&lang=js"
export * from "./RuleEffective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports